import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { setLoading, setUserDetails, signout } from "../feature/authSlice";
import {store} from '../feature/store'

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const genericUrl="https://vendortopay.in/GenericV2.0/"

export const errorGet = (error) => {
  return error
}


// Function to check and refresh access token if expired
// async function manageAccessToken() {
//   let accessToken = localStorage.getItem('access_token');
//   let decodedToken = jwtDecode(accessToken);
//   let currentDate = new Date();
// console.log(Date.now())
// console.log(Date.now() >=decodedToken.exp  * 1000)
//   // Check if token is expired (JWT exp is in seconds)
//   if (currentDate.getTime() >=decodedToken.exp  * 1000) {
//     // Token expired, refresh token
//     return await refreshAccessToken();
//   }

//   return accessToken;
// }

// Function to check and refresh access token if expired
async function manageAccessToken() {
  let accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    // Handle the case where there is no access token in local storage
    return null;
  }

  let decodedToken = jwtDecode(accessToken);
  let currentDate = new Date();
  let tokenExpirationDate = new Date(decodedToken.exp * 1000);
  let tenMinutesInMillis = 10 * 60 * 1000;

  // console.log("Current Time:", Date.now());
  // console.log("Token Expiration Time:", tokenExpirationDate.getTime());

  // Check if current time is more than 10 minutes past token expiration
  if (currentDate.getTime() > tokenExpirationDate.getTime() + tenMinutesInMillis) {
    // Token is more than 10 minutes past expiration, log out
    // console.log("Token is more than 10 minutes past expiration, log out")
    logout(store,signout);
    return null;
  }

  // Check if token is expired or within the 10-minute window
  if (currentDate.getTime() >= tokenExpirationDate.getTime()) {
    // Token expired or within 10 minutes past expiration, refresh token
    // console.log("Token expired or within 10 minutes past expiration, refresh token")
    return await refreshAccessToken();
  }

  return accessToken;
}

const logout = (store, dispatchAction) => {
      store.dispatch(dispatchAction());
      store.dispatch(setLoading(false))
      store.dispatch(setUserDetails(null))
      localStorage.removeItem("Ok");
  // customDispatch(signout(false));
  // window.location.replace('/login');
  // Add any additional logout logic here (e.g., redirect to login page)
  // console.log("Logged out due to token expiration");
};


// Function to refresh access token
async function refreshAccessToken() {
  try {
    let url = process.env.REACT_APP_BASE_URL + "Identity/api/Account/RefreshToken";
    const response = await axios.post(url, {
      AccessToken: localStorage.getItem('access_token'),
      RefreshToken: 'string', // Replace with your actual refresh token logic
    }, {
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });
    localStorage.setItem('access_token',response.data.result.Token_chr)
    // Assuming response.data.result.token_chr is the new access token
    return response.data.result.Token_chr;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
}

export function serviceCallAuth(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = process.env.REACT_APP_BASE_URL +requestData.url;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}

export function serviceCallLogin(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = requestData.baseUrl;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: process.env.REACT_APP_BASE_URL+requestData.url
      ,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}
export function serviceCallIdentity(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = requestData.baseUrl;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: process.env.REACT_APP_BASE_URL+requestData.url
      ,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}
export async function serviceCall(requestData) {
  localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}

  return new Promise(async (resolve, reject) => {
    try {
      let url = process.env.REACT_APP_BASE_URL + requestData.url;

      const request = {
        method: requestData.method || "get",
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json-patch+json",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
        url: url,
      };

      if (requestData.method === "post" || requestData.method === "put") {
        request["data"] = { ...requestData.data } || {};
      } else {
        request["params"] = { ...requestData.data } || {};
      }

      const response = await axios(request);
      resolve(response);
    } catch (error) {
      console.error("Error in serviceCall:", error);
      reject(error);
    }
  });
}

export async function serviceCallSendDataArray(requestData) {
  localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = requestData.data;
    } else {
      request["params"] = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallSendDataArray:", error);
    throw error;
  }
}


export async function serviceCallGenerate(requestData) {
  localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post") {
      request["data"] = requestData.data;
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallGenerate:", error);
    throw error;
  }
}


export async function serviceCallPostParms(requestData) {
  localStorage.setItem("requestData", JSON.stringify(requestData)); // Store requestData as string
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        timezone: timeZone,
      },
      url: url,
      params: requestData.params || {}, // Pass data as params for all requests
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request.data = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallPostParms:", error);
    throw error;
  }
}


// export function callRefreshToken(requestData) {

//   return new Promise((resolve, reject) => {
//     let url = process.env.REACT_APP_BASE_URL + "Auth/RegenerateToken";

//     const request = {
//       method: "post",
//       url:  process.env.REACT_APP_BASE_URL,
//     };

//     request["data"] = {
//       refresh_token_chr: localStorage.getItem("refresh_token"),
//     };

//     axios(request)
//       .then((response) => {
//         localStorage.setItem("access_token", response.data.access_token);
//         localStorage.setItem("refresh_token", response.data.refresh_token);
//         serviceCall(requestData);
//         resolve(response);
//         window.location.reload();
//       })
//       .catch((error) => {

//         localStorage.clear();
//         // dispatch(signout())
//         // alert("Logged out due to inactivity")
//         window.location.reload();

//         reject(error);
//       });
//   });
// }

export async function formDataCommonFunction(formData, url) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.post(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunction:", error);
    throw error;
  }
}


export async function formDataCommonFunctionWithParamsAndBody(formData, url, params) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.post(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      params: params || {},
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunctionWithParamsAndBody:", error);
    throw error;
  }
}

export function formDataCommonFunctionUnAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



export async function formDataCommonFunctionPut(formData, baseUrl, url) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.put(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunctionPut:", error);
    throw error;
  }
}

export function formDataFunctionWithoutAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error("Error in formDataFunctionWithoutAuth:", error);
        reject(error);
      });
  });
}


export function formDataCommonFunctionPutWithoutAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .put(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        if (error.response && (error.response.status === 401 || error.response.status === 406)) {
          localStorage.clear();
          window.location.reload();
        } else if (error.response) {
          errorGet(error.response.status);
        } else {
          console.error("Network error:", error.message);
        }
      });
  });
}


export async function gstinCall(requestData) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {
    localStorage.setItem("requestData", JSON.stringify(requestData));

    let url = genericUrl + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request.data = { ...requestData.data } || {};
    } else {
      request.params = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in gstinCall:", error);
    throw error;
  }
}

